import { useState, type ChangeEvent, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useAccountInfo } from '../../api/queryHooks/account';
import FacebookButton from "./FacebookButton";
import GoogleButton from "./GoogleButton";
import OrDivider from './OrDivider';
import './EmailInput.scss';
import './socialLoginButtons.scss';

interface EmailInputProps {
  onEmailComplete: (email: string) => void;
}

const EmailInput = ({ onEmailComplete }: EmailInputProps) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const { data: accountInfo } = useAccountInfo();

  // Mirrors the enabled-check each social button applies internally (they
  // return null unless the shop configured credentials) — needed here so the
  // "or" divider only renders when a social button will actually follow it.
  const fb = accountInfo?.setting?.facebook_login;
  const google = accountInfo?.setting?.google_login;
  const hasSocialLogin = !!(fb?.enabled && fb.app_id) || !!(google?.enabled && google.client_id);

  const onEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  }

  const handleNextClick = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onEmailComplete(email);
  }

  return (
    <>
    {/* noValidate: the browser's type="email" check is ASCII-only, and an
        existing account must log in whatever its address looks like. The
        format is checked when this turns into a signup (Register). */}
    <form onSubmit={handleNextClick} noValidate>
      <div className="field">
        <label className="label">{t('login.email_label')}</label>
        <div className="email-login-row">
          <div className="control">
            <input className="input" type="email" autoComplete="username" placeholder={t('login.email_placeholder')} value={email} autoFocus onChange={onEmailChange}/>
          </div>
          <div className="control">
            <button className="button is-primary">{t('login.button_email_login')}</button>
          </div>
        </div>
      </div>
    </form>
    { hasSocialLogin && (
      <>
        <OrDivider />
        <div className="social-login-buttons">
          <FacebookButton />
          <GoogleButton />
        </div>
      </>
    ) }
    </>
  );
}

export default EmailInput;
